import { Component } from '@angular/core';
import { SceltaPdeStrutturaComponent } from '../scelta-pde-struttura/scelta-pde-struttura.component';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-mirko-dev',
  imports: [SceltaPdeStrutturaComponent],
  templateUrl: './mirko-dev.component.html',
  styleUrl: './mirko-dev.component.css',
    providers: [provideNativeDateAdapter(), { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }]
})
export class MirkoDevComponent {



  nextStep(){}
}
